import React, {Component} from 'react'
import {Button, Card, Col, Form, Icon, Input, Row, Switch, Cascader} from 'antd'
import Simple from './Table'
import getDate from 'util/ConfigDates'
import {connect} from 'react-redux'

import {
  fetchStores,
  fetchCategories,
  fetchCouponsData,
} from 'appRedux/actions/Coupons'

class Cupons extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dateFrom: getDate('dateFrom'),
      dateTo: getDate('dateTo'),
      storeId: '0',
    }
  }

  componentDidMount() {
    this.props.fetchStores()
    this.props.fetchCategories()
    this.props.fetchCouponsData(this.state)
  }

  render() {
    return <Simple />
  }
}

export default connect(
  null,
  {fetchStores, fetchCategories, fetchCouponsData},
)(Cupons)



// WEBPACK FOOTER //
// ./src/routes/main/Cupons/admin/index.js